import { render } from "./IndexTypesArticle.vue?vue&type=template&id=6f67b596"
import script from "./IndexTypesArticle.vue?vue&type=script&lang=js"
export * from "./IndexTypesArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__